import styled from 'styled-components';

const Loader = () => {
  return (
    <StyledWrapper>
      <div className="loader">
        <div className="circle" />
        <div className="circle" />
        <div className="circle" />
        <div className="circle" />
        <div className="circle" />
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .loader {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle {
    width: 20px;
    height: 20px;
    background-image: linear-gradient(135deg, #1b4fd1 0%, #6fcf97 100%);
    border-radius: 50%;
    margin-right: 1rem;
    animation: pulse 1.2s ease-in-out infinite;
  }

  .circle:nth-child(2) {
    animation-delay: 0.2s;
    background-image: linear-gradient(135deg, #1f5ee0 0%, #7bd9b0 100%);
  }

  .circle:nth-child(3) {
    animation-delay: 0.4s;
    background-image: linear-gradient(135deg, #2a6bf3 0%, #5dcaa8 100%);
  }

  .circle:nth-child(4) {
    animation-delay: 0.6s;
    background-image: linear-gradient(135deg, #3b7cf5 0%, #55c19e 100%);
  }

  .circle:nth-child(5) {
    animation-delay: 0.8s;
    background-image: linear-gradient(135deg, #4c8df8 0%, #4bb591 100%);
  }

  @keyframes pulse {
    0% {
      transform: scale(0.8);
      opacity: 0.7;
    }

    50% {
      transform: scale(1);
      opacity: 1;
    }

    100% {
      transform: scale(0.8);
      opacity: 0.7;
    }
  }`;

export default Loader;
